<template>
  <HotelArtworkLayout :head-title="headTitle" img-custom-class="hotel-room-custom-size">
    <template v-slot:imageSlot>
      <div class="hotel-box-image room-custom-size" ref="imageDom">
        <img class="room-image" ref="imgFood" :src="imgSrc ? imgSrc : image" alt="">
        <div class="content-center">
          <div class="box-detail">
            <template v-if="screenWidth <= 767">
              <gen-center-component
                :inputText="roomTypeName"
                :inputText2="roomTypeName2"
                :previewOptions="qtyOptionsMobile"
                :previewVertOffset="qtyOptionsMobile.previewVertOffset">
              </gen-center-component>
            </template>
            <template v-else>
              <gen-center-component
                :inputText="roomTypeName"
                :inputText2="roomTypeName2"
                :previewOptions="qtyOptionsDesktop"
                :previewVertOffset="qtyOptionsDesktop.previewVertOffset">
              </gen-center-component>
            </template>

          </div>
        </div>
      </div>
    </template>
    <template v-slot:formSlot>
      <div class="box-form">
        <input type="file" @change="onFileChanged" class="hidden-files" ref="addFile">
        <button class="btn-color change-pic" @click="onUpload">{{ btn_upload_label }}</button>

        <div class="box-input-add">
          <div class="container-box-input">
            <div class="box-label">
              <label class="label-left">{{ $t('ROOM_TYPE_NAME') }}</label>
              <label class="label-right">
                <span v-text="roomTypeName.length"></span>
                <span ref="maximum_store">{{ `/${ $t('ROOM_TYPE_NAME_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('ROOM_TYPE_NAME_LIMIT')"
                v-model="roomTypeName"
                :placeholder="$t('INSERT_ROOM_TYPE_NAME_LABEL')"
              />
            </div>
          </div>
          <div class="box-add" v-if="isShow">
            <div class="plus-icon" @click="add_store_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('ADD_LINE_LABEL') }}</p>
          </div>
        </div>
        <div class="box-input-add" v-if="storebox2">
          <div class="container-box-input">
            <div class="box-label" >
              <label class="label-left">{{ $t('ROOM_TYPE_NAME_LINE_2') }}</label>
              <label class="label-right">
                <span v-text="roomTypeName2.length"></span>
                <span ref="maximum_store">{{ `/${ $t('ROOM_TYPE_NAME_LIMIT') }` }}</span>
              </label>
            </div>
            <div class="border-linear">
              <input
                type="text"
                :maxlength="$t('ROOM_TYPE_NAME_LIMIT')"
                v-model="roomTypeName2"
                :placeholder="$t('INSERT_ROOM_TYPE_NAME_LABEL')"
              />
            </div>
          </div>
          <div class="box-remove">
            <div class="remove-icon" @click="rm_store_row">
              <div class="line-one"></div>
              <div class="line-two"></div>
            </div>
            <p class="info-texts">{{ $t('REMOVE_LINE_LABEL') }}</p>
          </div>
        </div>

        <div class="back" id="open_update" @click="toggleBackPopup">
          <div><p>{{ $t('BACK_LABEL') }}</p></div>
        </div>
        <button class="btn-color save-pic" ref="save_pic" @click="toImage">{{ $t('SAVE_IMAGE_LABEL') }}</button>

        <div :class="['popup-saved', 'animatedFadeInUp', 'animated', savedPopupClass]" id="popup-saved">
          <p>{{ $t('SAVE_IMAGE_ALREADY_LABEL') }}</p>
          <img src="@/assets/img/icons/akar-icons_circle-check.png" alt=""/>
        </div>
        <div :class="['popup-back', backPopupClass]">
          <BackPopup :toggleBackPopup="toggleBackPopup" />
        </div>
      </div>
    </template>
  </HotelArtworkLayout>
</template>

<script>
import HotelArtworkLayout from '@/layouts/HotelArtworkLayout.vue';
import BackPopup from '@/components/Popup/BackPopup.vue';
import { qrCodeFoodSize, qrCodeFoodSizeM } from '@/config/enum';
import { generateImageAndDownload } from '@/utils';
import bgEmptyHotel from '@/assets/img/background/BG_OTA.png';
import generateTextCenter from '@/components/GenerateText/GenerateTextCenter.vue';

export default {
  name: 'HotelRoom',
  metaInfo: {
    title: 'Hotel Room',
  },
  components: {
    HotelArtworkLayout,
    BackPopup,
    genCenterComponent: generateTextCenter,
  },
  props: {
    headTitle: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const windowSize = {
      target: {
        innerWidth: window.innerWidth,
      },
    };
    this.onResize(windowSize);
  },
  data() {
    return {
      screenWidth: 0,
      imgSrc: '',
      imgSrcName: 'RBH_shop.jpg',

      qrCodeSize: qrCodeFoodSize,
      qrCodeSizeM: qrCodeFoodSizeM,
      qtyOptionsDesktop: {
        safeWidth: 900,
        previewHeight: 240,
        previewVertOffset: 0,
        originalFontSize: 198,
      },
      qtyOptionsMobile: {
        safeWidth: 360,
        previewHeight: 120,
        previewVertOffset: 0,
        originalFontSize: 120,
      },

      roomTypeName: '',
      roomTypeName2: '',
      btn_upload_label: this.$t('UPLOAD_IMAGE_LABEL'),

      image: bgEmptyHotel,
      isShowBackPopup: false,
      isShowSavedPopup: false,
      isShowIntroducePopup: false,
      isShowShadow: false,
      storebox2: false,
      isShow: true,
    };
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    qtyOptions() {
      // if (this.screenWidth <= 767) {
      //   console.log(1);
      return this.qtyOptionsMobile;
      // }
      // console.log(2);
      // return this.qtyOptionsDesktop;
    },
    backPopupClass() {
      return this.isShowBackPopup ? 'popup-show' : '';
    },
    savedPopupClass() {
      return this.isShowSavedPopup ? 'fadeInUp' : '';
    },
    introducePopupClass() {
      return this.isShowIntroducePopup ? 'popup-show' : '';
    },
    shadowImageClass() {
      return this.isShowShadow ? 'format-overlay-template' : '';
    },
    qtyText() {
      return '';
    },
  },
  methods: {
    add_store_row() {
      this.storebox2 = true;
      this.isShow = false;
    },
    rm_store_row() {
      this.storebox2 = false;
      this.roomTypeName2 = '';
      this.isShow = true;
    },
    onResize(e) {
      this.screenWidth = e.target.innerWidth;
    },
    toggleIntroducePopup() {
      this.isShowIntroducePopup = !this.isShowIntroducePopup;
    },
    toggleBackPopup() {
      this.isShowBackPopup = !this.isShowBackPopup;
    },
    onFileChanged(e) {
      this.btn_upload_label = this.$t('CHANGE_IMAGE_LABEL');
      this.isShowShadow = true;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
    },
    createImage(file) {
      // const image = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        const image = e.target && e.target.result ? e.target.result : '';
        if (typeof image === 'string') {
          this.imgSrc = image;
          this.imgSrcName = file.name;
        }
      };
      reader.readAsDataURL(file);
    },
    toImage() {
      const imageNode = this.$refs.imageDom;
      this.generateImageAndDownload(imageNode, window.innerWidth <= 767 ? 400 : 1200);
    },
    onSave() {
      this.isShowSavedPopup = true;
      setTimeout(() => {
        this.isShowSavedPopup = false;
      }, 3000);
    },
    generateImageAndDownload(imageNode, size) {
      generateImageAndDownload(imageNode, size, this.imgSrcName, this.onSave, 1024, 1000);
    },
    onUpload() {
      this.$refs.addFile.click();
    },
  },
};
</script>

<style scoped>

</style>
